// extracted by mini-css-extract-plugin
export default {"boardRow":"board_boardRow__6fmOC","status":"board_status__3JXM9"};